import * as React from 'react';
import * as styles from './TargetPreviewPopup.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IAIcon } from '../../../icon/Icon';
import { IAMessageBar } from '../../../messageBar/MessageBar';
import { TreeTargetingForGroups } from '../../../treeTargetingForGroups';

export interface ITargetPreviewPopupProps {
  navigatorStore?: NavigatorStore;
  onClose: () => void;
}

export interface ITargetPreviewPopupState {
}

@inject('navigatorStore')
@observer
export default class TargetPreviewPopup extends React.Component<ITargetPreviewPopupProps, ITargetPreviewPopupState> {

  private readonly localizationService = new LocalizationService();

  constructor(props: ITargetPreviewPopupProps) {
    super(props);
    this.state = {
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {

    return (
      <div
        className={styles.IA_popupBackground}
        style={{
        }}
        onClick={() => this.props.onClose()}
      >
        <div
          className={styles.IA_popupContentBox}
          onClick={(e) => e.stopPropagation()}
          style={{
          }}
        >
          <IAIcon
            title={"Close"}
            size={24}
            color={"gray"}
            style={{
              float: "right",
              borderRadius: 24,
              width: 24,
              height: 24,
              lineHeight: "24px",
              padding: 0
            }}
            onClick={() => this.props.onClose()}
          />
          <h1 style={{
            color: "#333333",
            fontSize: 19,
            width: "100%"
          }}>
            {this.localizationService.strings.Navigator_Admin_TargetPreview}
          </h1>

          <IAMessageBar
            type="information"
            onDismiss={() => { }}
            icon="Info"
            content={this.localizationService.strings.Navigator_Admin_TargetPreviewMessage}
            showIcon={false}
            showCloseButton={false}
            style={{
              marginBottom: 20
            }}
          />
          <TreeTargetingForGroups
            environment={this.props.navigatorStore.environment}
            tenant={this.props.navigatorStore.tenant.replace(".sharepoint.com", "")}
            application={"navigator"}
            applicationData={this.props.navigatorStore.applicationSettings}
            instance={this.props.navigatorStore.instance}
            selectedGroupIds={this.props.navigatorStore.targetedPreviewIds}
            showTarget
            hideOptions
            highlightColor={this.props.navigatorStore.adminColor}
            onShowTargetChanged={() => { }}
            onGroupIdsUpdated={(ids: number[]) => {
              this.props.navigatorStore.targetedPreviewIds = ids;
              this.props.navigatorStore.getTopItems();
            }}
          />
        </div>
      </div>
    );
  }
}